import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="card p-6">
        <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          This Privacy Policy describes how TRENDZ collects, uses, and protects your
          information.
        </p>

        <div className="space-y-6 text-gray-600 dark:text-gray-400">
          <section>
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">Information We Collect</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>Account information (name, email, phone)</li>
              <li>Order and delivery details</li>
              <li>Payment method selection (we do not store card details)</li>
              <li>Basic usage data (pages visited, device/browser info)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">How We Use Your Information</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>To process orders and deliver products</li>
              <li>To provide customer support</li>
              <li>To send order updates and important service messages</li>
              <li>To improve our website experience</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">Cookies</h2>
            <p>
              We may use cookies to keep you logged in and improve site performance. You can
              control cookies through your browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">Data Security</h2>
            <p>
              We take reasonable steps to protect your data. However, no method of transmission
              over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">Contact</h2>
            <p>
              If you have any questions about this policy, contact us at{' '}
              <strong>trendz.supp0rt@gmail.com</strong> or <strong>03708426610</strong>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

